module.exports = __webpack_public_path__ + "static/media/NI.7900f89a.svg";